import classNames from 'classnames'
import { ErrorMessage, useField } from 'formik'

import type { ReactElement } from 'react'
import type { Placement } from '~/components/Inputs/Basic/DateInput'

import BasicDateInput from '~/components/Inputs/Basic/DateInput'

import '../../input-common.scss'

interface Props {
  darkBackground?: boolean
  disabled?: boolean
  focus?: boolean
  label?: string
  name: string
  placeholder?: string
  placement?: Placement
  required?: boolean
  withMaxDate?: Date
  withMinDate?: Date
  withTime?: boolean
}

const DateInput = ({ focus, label, name, placeholder, required, ...props }: Props): ReactElement => {
  /** Local state */

  const [field, { error, touched }] = useField<string | undefined>(name)

  const fieldContainerClasses = classNames('field-container', { erroneous: touched && error })

  /** Render */

  return (
    <div className="input-component date-input-component input-container">
      <div className={fieldContainerClasses}>
        <BasicDateInput
          autoFocus={focus}
          className="input-wrapper"
          {...field}
          {...props}
          dateValue={field.value}
          label={label}
          placeholder={placeholder}
          required={required}
        />
      </div>
      {touched && error ? <ErrorMessage className="error-message" component="span" name={name} /> : null}
    </div>
  )
}

export default DateInput
